<template>
    <v-autocomplete
      v-model="internalValue"
      :items="dropdownItems"
      :item-value="itemValue"
      :item-text="itemText"
      :label="field.label"
      :required="field.is_required"
      multiple
      outlined
      dense
      clearable
    ></v-autocomplete>
  </template>
  
  <script>
  export default {
    props: {
      modelValue: {
        type: Array,
        default: () => [],
      },
      field: {
        type: Object,
        required: true,
      },
    },
    emits: ['update:modelValue'],
    data() {
      return {
        internalValue: this.modelValue,
      };
    },
    computed: {
      dropdownItems() {
        return this.field.dropdown_values.split(',').map(value => ({ text: value, value }));
      },
      itemValue() {
        return 'value';
      },
      itemText() {
        return 'text';
      },
    },
    watch: {
      modelValue(newValue) {
        this.internalValue = newValue;
      },
      internalValue(newValue) {
        // this.$emit('update:modelValue', newValue);
        this.$emit('custom-update', newValue);
      },
    },
  };
  </script>
  